module.exports = __webpack_public_path__ + "static/media/mapIMG.33add05c.png";